/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Ausrichtung',
  'company-hub.links-menu-extension.all.borders.label-text': 'Alle Seiten',
  'company-hub.links-menu-extension.background.color': 'Hintergrundfarbe',
  'company-hub.links-menu-extension.background.title': 'Hintergrund',
  'company-hub.links-menu-extension.border.color': 'Rahmenfarbe',
  'company-hub.links-menu-extension.border.position': 'Rahmenposition',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Unterer Rand',
  'company-hub.links-menu-extension.center.option': 'Zentriert',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Wichtige Links hinzufügen',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Verknüpfen',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Verwandte Links gruppieren',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Sie haben die maximale Anzahl an Unterebenen erreicht.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menü',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Abbrechen',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Löschen',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Durch diese Aktion werden das Element und alle ihm untergeordneten Elemente gelöscht.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Element löschen',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Unterelement hinzufügen',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Element löschen',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Eigenschaften bearbeiten',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Nach unten verschieben',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Nach oben verschieben',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Link öffnen',
  'company-hub.links-menu-extension.config-panel.items.label': 'Elemente',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'Sie haben die maximale Anzahl an Elementen für ein Link-Menü erreicht.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Neues Element',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Fügen Sie Links hinzu und organisieren Sie sie mit Untermenüs. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Weitere Informationen zum Link-Menü',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Fügen Sie Verknüpfungen hinzu und organisieren Sie sie mit Untermenüs.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Abbrechen',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Bestätigen',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Füllen Sie dieses Feld aus.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Anzeigetext',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Elementname',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Bestätigen',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Mehr',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Stile',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'Sie haben die maximale Anzahl an Elementen für ein Link-Menü erreicht.',
  'company-hub.links-menu-extension.config-panel.title': 'Link-Menü',
  'company-hub.links-menu-extension.fixed.option': 'Oben fixiert',
  'company-hub.links-menu-extension.left.option': 'Links',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Mehr',
  'company-hub.links-menu-extension.manifest.extension-description':
    'Fügen Sie dem Unternehmens-Hub mehrere Links und Untermenüs hinzu.',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Link-Menü',
  'company-hub.links-menu-extension.manifest.extension-title': 'Link-Menü [Neu]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'Über uns',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Team 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Zusatzleistungen',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Teams',
  'company-hub.links-menu-extension.no.border.label-text': 'Keine',
  'company-hub.links-menu-extension.right.option': 'Rechts',
  'company-hub.links-menu-extension.section.collapse.label': 'Bereich reduzieren',
  'company-hub.links-menu-extension.section.expand.label': 'Bereich erweitern',
  'company-hub.links-menu-extension.selected.state.color': 'Farbe für Zustand auswählen',
  'company-hub.links-menu-extension.text.color': 'Textfarbe',
  'company-hub.links-menu-extension.text.title': 'Text',
};
